import { Ref, ref } from 'vue';
import { LinkModel } from '@/types/B2CcontentServerContract';

const link: Ref<LinkModel | undefined> = ref();

export default function useProductDetailConfigurator() {
    const setLink = (value: LinkModel | undefined) => {
        link.value = value;
    };

    return {
        setLink,
        link,
    };
}
